(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v5"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".js_product_v5");
  if (!slider) return;

  setInterval(function () {
    slider.scrollBy({ left: 220, behavior: 'smooth' });
    if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth) {
      slider.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }, 3000);
});

  } catch(e) { console.error(e); }
})();
})();
